module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "evaluateSuccess"
  }, [_c('mt-header', {
    attrs: {
      "title": "评价成功"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h1', [_c('icon', {
    attrs: {
      "name": "check-circle"
    }
  }), _vm._v("评价成功")], 1), _vm._v(" "), _c('p', [_vm._v("感谢你的积极评价，这对专家提升服务水平非常有用！我们期待可以再次为您服务！")])]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.zhidao
    }
  }, [_vm._v("知道了")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e3ca09c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/evaluateSuccess.vue
// module id = 1277
// module chunks = 1